/**
 * Modelo padrão: gráfico de velocidade + scroll temporal + faixas telemetria/máquina.
 *
 * Validado em Operações e App de Campo → Rastreamento (jul/2026).
 * Documentação completa: .cursor/rules/grafico-rastreamento-campo.mdc
 *
 * Ao replicar em outro mapa, importar deste módulo em vez de remontar props/helpers.
 */

import { buildDisplayActivityLanes } from "./GraphActivityLanesLayer";

/** Props fixas do LineGraph para o modelo de rastreamento aprovado. */
export const FIELD_TRACKING_CHART_LINE_PROPS = {
  brushOnlyZoom: true,
};

/**
 * Monta faixas de telemetria + máquina alinhadas ao gráfico.
 *
 * @param {object} tracking - resposta field-tracking (activityLanes, machines, operatorGraphLines)
 * @param {Array} graphSeries - série do gráfico (buildGraphSeriesFromLines)
 */
export function buildFieldTrackingChartLanes(tracking, graphSeries) {
  if (!tracking) return [];

  return buildDisplayActivityLanes(
    {
      activityLanes: tracking.activityLanes || [],
      machines: tracking.machines || [],
      operatorPointCount: tracking.operatorPointCount || 0,
    },
    graphSeries || []
  );
}

/**
 * focusBrushRange seguro: reseta o scroll só quando o mapa/dados mudam (mapSalt).
 * Não passar startIndex/endIndex fixos a cada render.
 */
export function fieldTrackingBrushReset(mapSalt) {
  return { token: mapSalt };
}

export {
  buildGraphSeriesFromLines,
  extractRawPathPoints,
  rebuildTrackingLines,
  stoppedPointsFromLines,
} from "./fieldAppTrackingUtils";

export {
  buildDisplayActivityLanes,
  GRAPH_PLOT_MARGIN_LEFT,
  GRAPH_PLOT_MARGIN_RIGHT,
  GRAPH_Y_AXIS_WIDTH,
  stackedGraphHeight,
} from "./GraphActivityLanesLayer";
